import type { Color } from "antd/es/color-picker";

export type LayerDisplayMode = 'collector' | 'form' | 'date' | 'advanced';

export interface LayerStyles {
  mode: LayerDisplayMode;
  collectorColors?: Record<number, string>; // userId -> hexColor
  formColors?: Record<string, string>; // formUuid -> hexColor
  point: {
    color: string;
    radius: number;
    strokeWidth: number;
    strokeColor: string;
    opacity: number;
  };
  line: {
    color: string;
    width: number;
    opacity: number;
    dashPattern?: number[];
  };
  polygon: {
    fillColor: string;
    fillOpacity: number;
    strokeColor: string;
    strokeWidth: number;
    strokeOpacity: number;
    dashPattern?: number[];
  };
  labels: {
    enabled: boolean;
    color: string;
    haloColor: string;
    haloWidth: number;
    size: number;
    minZoom: number;
  };
}

export const defaultStyles: LayerStyles = {
  mode: 'collector',
  collectorColors: {},
  formColors: {},
  point: {
    color: '#FF6B35',
    radius: 8,
    strokeWidth: 2,
    strokeColor: '#FFFFFF',
    opacity: 0.8,
  },
  line: {
    color: '#FF6B35',
    width: 3,
    opacity: 0.8,
  },
  polygon: {
    fillColor: '#FF6B35',
    fillOpacity: 0.3,
    strokeColor: '#FF6B35',
    strokeWidth: 2,
    strokeOpacity: 0.8,
  },
  labels: {
    enabled: true,
    color: '#1e293b',
    haloColor: '#ffffff',
    haloWidth: 1.6,
    size: 16,
    minZoom: 10,
  },
};

export const dashOptions = [
  { label: 'Liền nét', value: undefined },
  { label: 'Gạch ngang', value: [4, 4] },
  { label: 'Chấm', value: [1, 3] },
  { label: 'Gạch chấm', value: [8, 4, 2, 4] },
];

export const colorToHex = (color: Color | string): string => {
  if (typeof color === 'string') return color;
  return color.toHexString();
};
